import { render } from "./TemplateForm.vue?vue&type=template&id=514b7024&scoped=true"
import script from "./TemplateForm.vue?vue&type=script&lang=js"
export * from "./TemplateForm.vue?vue&type=script&lang=js"

import "./TemplateForm.vue?vue&type=style&index=0&id=514b7024&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514b7024"]])

export default __exports__